import { render, staticRenderFns } from "./Spring.vue?vue&type=template&id=1644b064&scoped=true&"
import script from "./Spring.vue?vue&type=script&lang=js&"
export * from "./Spring.vue?vue&type=script&lang=js&"
import style0 from "./Spring.vue?vue&type=style&index=0&id=1644b064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1644b064",
  null
  
)

export default component.exports